export enum SchemeTokenCardType {
  Visa = 'VISA',
  Mastercard = 'MASTERCARD',
}
